import { useLinkRelValue } from "hooks";
import { Link as ChakraLink } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { LinkProps } from "./Link.d";

const Link = ({ text, href, isExternal = false, sbEditable }: SbEditableComponentProps<LinkProps>) => {
  const relValue = useLinkRelValue(href);

  return (
    <ChakraLink rel={relValue} href={href} isExternal={isExternal} fontSize="md" _visited={{}} {...sbEditable}>
      {text}
    </ChakraLink>
  );
};

export default Link;
